export default function LockIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <rect x="3.5" y="8.5" width="13" height="9" rx="3" />
      <path d="M6.5 8.5v-2a3.5 3.5 0 0 1 7 0v2" />
      <circle cx="10" cy="12.5" r="1" />
    </svg>
  );
}
